import './App.css';

import TerritoryApplication from './container/allRoutes';

function App() {
  return (
    <div className='App'>
      <TerritoryApplication />
    </div>
  );
}

export default App;
